import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { FAQProps } from "../../../../types/components/FAQsProps.types";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useContext } from "react";
import { ThemeContext } from "../../../../contexts";

const FAQ = ({ eachFAQ, defaultExpanded }: FAQProps): JSX.Element => {
	const { theme } = useContext(ThemeContext);

	return (
		<div className="each-FAQ">
			<Accordion
				style={{
					boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px"
				}}
				defaultExpanded={defaultExpanded}
			>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon style={{ color: theme?.primary_color }} />}
					style={{
						fontWeight: "bold",
						color: theme?.primary_color,
						marginLeft: "1rem",
						display: "flex",
						marginRight: "1rem"
					}}
				>
					{eachFAQ.question}
				</AccordionSummary>
				<AccordionDetails style={{ color: "#b9b7b7" }}>{eachFAQ.answer}</AccordionDetails>
			</Accordion>
		</div>
	);
};

export default FAQ;
